import React from 'react';
import { DnDTableExample } from './DnDTableExample';

export const DnDTableDemo: React.FC = () => {
  return (
    <div className="demo-container">
      <h1>DnDTable Component Demo</h1>
      <p>
        This component extends the functionality of the standard Table component with drag and drop capabilities powered
        by @dnd-kit.
      </p>

      <div className="features">
        <h3>Key Features:</h3>
        <ul>
          <li>All standard Table features (sorting, pagination, selection)</li>
          <li>Drag and drop row reordering</li>
          <li>Visual feedback during dragging operations</li>
          <li>Support for expandable rows</li>
          <li>Keyboard accessibility</li>
        </ul>
      </div>

      <div className="demo-wrapper">
        <DnDTableExample />
      </div>

      <div className="usage-info">
        <h3>Usage Example:</h3>
        <pre>
          {`import { DnDTable } from '@co4/components';

// Define your columns
const columns = [
  {
    id: 'name',
    field: 'name',
    header: 'Name',
    sort: true
  },
  // ... more columns
];

// Your component
const MyComponent = () => {
  const [data, setData] = useState(myData);
  
  const handleReorder = (reorderedData) => {
    setData(reorderedData);
  };
  
  return (
    <DnDTable
      data={data}
      columns={columns}
      rowSelection={true}
      onSelectionChange={(selected) => console.log(selected)}
      noDataText="No data found"
      variant="filled"
      draggable={true}
      onReorder={handleReorder}
      expandable={true}
    />
  );
};`}
        </pre>
      </div>
    </div>
  );
};
